<template>
  <div v-if="readable" :class="`input ${editable ? '' : 'disabled'} ${viewdata}`">
    <label v-if="viewdata == 'full'">{{fielddata.label}}</label>
    <div>
      <select ref="sel" @change="onSelect" :value="_.get(itemdata[0],
        [fielddata.model, fielddata.name].filter(Boolean).join('.'))"
				:disabled="!editable"
				>
        <option v-if="itemdata.length > 1">[Batched]</option>
        <option v-else v-bind:value="null">-</option>
        <option v-for="option in fielddata.options.split(',')" v-bind:value="option">
          {{ option }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Data from '../../main';

export default {
	name: 'Select',
	props: {
		item: Array,
		field: Object,
		view: String
	},
  computed: {
    // lodash in template
    _() {
      return _;
    },
  },
	watch: {
		item: function() {
			this.itemdata = this.item;

		},
	},
	data() {
    // this.item[0].value = _.get(this.item[0],
    //   [this.field.model, this.field.name].filter(Boolean).join('.'));

		return {
			itemdata: this.item,
			fielddata: this.field,
			viewdata: this.view,
			options: null,
			show: false,
			editable: Data.fieldWriteable(this.field.id, Data),
			readable: Data.fieldReadable(this.field.id, Data)
		};
	},

	methods: {

		onSelect: function( e ) {
			if (this.viewdata == 'full') {
				this.show = false;

				return this.$emit('saveTrigger', {
					name: this.field.name,
					value: e.target.value,
					model: this.field.model
				});
			}

			this.$Progress.start();

			this.$axios
				.put('/item', {
					batch: [this.itemdata[0].id],
					update: {[this.field.name]: e.target.value},
				})
				.then((response) => {
					// console.log(response);
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					this.$Progress.finish();
					this.itemdata[0].value = e.target.value;
					this.show = false;
				});
		},

	},
};

</script>

<style scoped>
  select, div{
    vertical-align: top;
    width: 100%;
    height:100%;
  }

  select{
    -webkit-appearance: none;
    border:none;
    background: none;
    outline: none;
    padding:4px;
  }

  .full select{
    border: 1px solid #efefef;
    margin-bottom: 20px;
  }

</style>
